import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import styles from './NotificationsSettings.module.scss';
import ReactTableComponent from 'components/ReactTableComponent';
import Checkbox from 'components/Checkbox';
import Tooltip from 'components/Tooltip';

const tooltipByCategory = {
  1: 'Информирование о получении важных сообщений из налогового органа',
  2: 'Информирование о начислении налогов, а также о появлении задолженности и переплаты по налогам',
  3: 'Ответы и актуальные статусы по обращениям из раздела «Жизненные ситуации»',
  4: 'Уведомления о работе личного кабинета. Узнавайте первыми о новых возможностях ЛКФЛ!',
};

class NotificationsSettings extends React.PureComponent {
  columns = [
    {
      Header: 'Категории уведомлений',
      accessor: 'categoryName',
      Cell: ({ original: { categoryId }, value }) => {
        const [visible, setVisible] = useState(false);

        return (
          <div className={'boo'}>
            <div className={'d-flex'} style={{ position: 'absolute' }}>
              <span className={'mr-4'}>{value}</span>
              <Tooltip
                content={tooltipByCategory[categoryId]}
                fixed={true}
                show={visible}
                onClose={() => setVisible(false)}
              />
            </div>
          </div>
        );
      },
    },
    {
      Header: 'Уведомления в личный кабинет',
      headerClassName: styles.center,
      className: styles.center,
      accessor: 'notifierCenterChannelEnable',
      Cell: ({
        original: { categoryId },
        column: { id },
        columnProps: {
          rest: { setValue },
        },
        value,
      }) => (
        <Checkbox
          name={`notification-group-${categoryId}`}
          value={value}
          onChange={(isChecked) => setValue(categoryId, id, isChecked)}
        />
      ),

      getProps: () => ({
        setValue: this.setValue,
      }),
    },
    {
      Header: () => {
        const [visible, setVisible] = useState(false);

        return (
          <div className={'boo'}>
            <span className={styles.pushHeader}>
              PUSH{' '}
              <Tooltip
                content={
                  'Чтобы получать Push-уведомления вам необходимо скачать мобильное приложение ЛК ФЛ в Google Play или App Store'
                }
                fixed={true}
                show={visible}
                onClose={() => setVisible(false)}
              />
            </span>
          </div>
        );
      },
      headerClassName: styles.center,
      className: styles.center,
      accessor: 'pushChannelEnabled',
      width: 200,
      Cell: ({
        original: { categoryId },
        column: { id },
        columnProps: {
          rest: { setValue },
        },
        value,
      }) => (
        <Checkbox
          name={`notification-group-${categoryId}`}
          value={value}
          onChange={(isChecked) => setValue(categoryId, id, isChecked)}
        />
      ),

      getProps: () => ({
        setValue: this.setValue,
      }),
    },
    {
      Header: () => (
        <div className={styles.email}>
          <span className={styles.full}>Электронная почта</span>
          <span className={styles.mobile}> E-mail</span>
        </div>
      ),
      headerClassName: styles.center,
      className: styles.center,
      accessor: 'emailChannelEnabled',
      width: 200,
      Cell: ({
        original: { categoryId },
        column: { id },
        columnProps: {
          rest: { setValue },
        },
        value,
      }) => (
        <Checkbox
          name={`notification-group-${categoryId}`}
          value={value}
          onChange={(isChecked) => setValue(categoryId, id, isChecked)}
        />
      ),

      getProps: () => ({
        setValue: this.setValue,
      }),
    },
  ];

  componentDidMount() {
    const { getNotificationsSettings } = this.props;
    getNotificationsSettings();
  }

  setValue = (categoryId, field, isChecked) => {
    const { settings, saveNotificationsSettings } = this.props;
    const target = settings.findIndex((item) => item.get('categoryId') === categoryId);
    saveNotificationsSettings(settings.update(target, (item) => item.set(field, isChecked)));
  };

  render() {
    const { settings, isUpdating, isLoading } = this.props;
    return (
      <div className={styles.notificationsSettings}>
        <h2>Настройка уведомлений</h2>
        <div className={styles.table}>
          {!isLoading && settings && (
            <ReactTableComponent
              columns={this.columns}
              tableData={settings.toJS()}
              theme={'blue'}
              isLoading={isUpdating}
            />
          )}
        </div>
      </div>
    );
  }
}

NotificationsSettings.propTypes = {
  settings: PropTypes.instanceOf(List),
  isLoading: PropTypes.bool,
  isUpdating: PropTypes.bool,
  getNotificationsSettings: PropTypes.func.isRequired,
  saveNotificationsSettings: PropTypes.func.isRequired,
};

export default NotificationsSettings;
